
function extendSSNFr (validator) {
  validator.extend('securitesocialefr', {
    validate: value => {
      value = value.split(' ').join('');
      let parsedNumber = parseInt(value.substring(0, 13));
      let parsedKey = parseInt(value.substring(13, 15));
      return (97-(parsedNumber % 97) == parsedKey);
    }
  });
}
export default extendSSNFr;
